<template>
  <div>
    <v-dialog persistent v-model="value" max-width="90%" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ getTitle() }}</span>
        </v-card-title>
        <v-card-text style="max-height: 700px">
          <v-layout wrap>
            <v-flex xs12>
              <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header>
                  <v-divider />
                  <v-stepper-step :complete="e1 > 1" :step="1">
                    Datos
                  </v-stepper-step>
                  <v-divider />
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content :step="1">
                    <v-layout row wrap justify-center>
                      <v-flex>
                        <v-form lazy-validation @submit.prevent="save">
                          <v-layout row class="separatorNotice">
                            <h2
                              class="font-weight-regular white--text separatorTittle"
                            >
                              Datos generales
                            </h2>
                          </v-layout>
                          <v-layout wrap row justify-center>
                            <v-flex x6 sm6>
                              <v-flex xs12>
                                <v-form
                                  lazy-validation
                                  @submit.prevent="submit"
                                >
                                  <v-layout
                                    wrap
                                    justify-space-around
                                    fill-height
                                    align-center
                                  >
                                    <v-flex xs12 sm12>
                                      <v-text-field
                                        label="Título"
                                        v-model="$v.workshopForm.name.$model"
                                        outline
                                        :error-messages="titleErrors"
                                        style="margin-top: 25px"
                                      />
                                    </v-flex>
                                    <v-flex xs12 sm12>
                                      <v-textarea
                                        label="Descripción"
                                        v-model="
                                          $v.workshopForm.description.$model
                                        "
                                        outline
                                        :error-messages="descriptionErrors"
                                      />
                                    </v-flex>
                                    <v-flex class="p-1">
                                      <workshop-image
                                        style="
                                          margin-left: 10px;
                                          margin-bottom: 20px;
                                        "
                                        v-model="
                                          $v.workshopForm.imageStorage.$model
                                        "
                                        :type="0"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-form>
                              </v-flex>
                            </v-flex>
                            <v-flex xs6 sm6 shrink />
                          </v-layout>
                          <v-layout row class="separatorNotice mt-2">
                            <h2
                              class="font-weight-regular white--text separatorTittle"
                            >
                              Agenda
                            </h2>
                          </v-layout>
                          <v-layout wrap row justify-center class="mt-2">
                            <v-flex x6 sm6>
                              <v-flex xs12>
                                <v-form
                                  lazy-validation
                                  @submit.prevent="submit"
                                >
                                  <v-layout
                                    wrap
                                    justify-space-around
                                    fill-height
                                    align-center
                                  >
                                    <v-flex lg6 xs12>
                                      <v-menu
                                        v-model="startDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            label="Fecha de inicio del taller"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                            :value="momentFormatStartDate"
                                            style="width: 80%"
                                            :error-messages="dateStartErrors"
                                          />
                                        </template>
                                        <v-date-picker
                                          header-color="primary"
                                          color="secondary"
                                          v-model="
                                            $v.workshopForm.strStartDate.$model
                                          "
                                          @input="startDateMenu = false"
                                          locale="es-419"
                                        />
                                      </v-menu>
                                    </v-flex>
                                    <v-flex lg6 xs12>
                                      <v-menu
                                        v-model="endDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            label="Fecha de fin del taller"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                            :value="momentFormatEndDate"
                                            style="width: 80%"
                                            :error-messages="dateEndErrors"
                                          />
                                        </template>
                                        <v-date-picker
                                          header-color="primary"
                                          color="secondary"
                                          v-model="
                                            $v.workshopForm.strEndDate.$model
                                          "
                                          @input="endDateMenu = false"
                                          locale="es-419"
                                        />
                                      </v-menu>
                                    </v-flex>
                                  </v-layout>
                                </v-form>
                              </v-flex>
                            </v-flex>
                            <v-flex xs6 sm6 shrink />
                          </v-layout>
                          <v-layout wrap row justify-center class="mt-2">
                            <v-flex x6 sm6>
                              <v-flex>
                                <v-form
                                  lazy-validation
                                  @submit.prevent="submit"
                                >
                                  <v-layout
                                    wrap
                                    justify-space-around
                                    fill-height
                                    align-center
                                  >
                                    <v-flex xs12 style="padding-right: 15px">
                                      <label>
                                        <b>Días que se impartirá</b>
                                      </label>
                                      <v-layout row wrap justify-center>
                                        <v-flex>
                                          <v-select
                                            v-model="
                                              $v.workshopForm.days.$model
                                            "
                                            :items="enableDays"
                                            item-text="nombre"
                                            item-value="id"
                                            chips
                                            label="Días"
                                            multiple
                                            return-object
                                            :dense="$vuetify.breakpoint.xsOnly"
                                            :error-messages="daysErros"
                                          />
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout style="margin-top: 10px">
                                    <v-flex lg6 xs12>
                                      <div
                                        :class="
                                          timeStartE.length === 0
                                            ? 'text-normal'
                                            : 'text-error'
                                        "
                                      >
                                        Hora de inicio
                                      </div>
                                      <div
                                        :class="
                                          timeStartE.length === 0
                                            ? 'border-class-notice'
                                            : 'border-class-notice-error'
                                        "
                                      >
                                        <div class="date-picker-notice">
                                          <v-icon
                                            class="clock-notice"
                                            color="gradiente"
                                          >
                                            schedule
                                          </v-icon>
                                          <vue-timepicker
                                            class="pickers"
                                            v-model="
                                              $v.workshopForm.timeSchedule
                                                .$model
                                            "
                                            :value="momentFormatStartTime"
                                            full-width
                                            drop-direction="up"
                                            format="hh:mm a"
                                            color="secondary"
                                            header-color="primary"
                                            manual-input
                                            hide-clear-button
                                            @change="timeStartError"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="time-error"
                                        v-if="timeStartE.length !== 0"
                                      >
                                        {{ timeStartE[0] }}
                                      </div>
                                    </v-flex>
                                    <v-flex lg6 xs12 style="margin-left: 10px">
                                      <div
                                        :class="
                                          timeEndE.length === 0
                                            ? 'text-normal'
                                            : 'text-error'
                                        "
                                      >
                                        Hora de término
                                      </div>
                                      <div
                                        :class="
                                          timeEndE.length === 0
                                            ? 'border-class-notice'
                                            : 'border-class-notice-error'
                                        "
                                      >
                                        <div class="date-picker-notice">
                                          <v-icon
                                            class="clock-notice"
                                            color="gradiente"
                                          >
                                            schedule
                                          </v-icon>
                                          <vue-timepicker
                                            class="pickers"
                                            v-model="
                                              $v.workshopForm.timeEndSchedule
                                                .$model
                                            "
                                            :value="momentFormaEndTime"
                                            full-width
                                            drop-direction="up"
                                            format="hh:mm a"
                                            color="secondary"
                                            header-color="primary"
                                            manual-input
                                            hide-clear-button
                                            @change="timeEndError"
                                            :disabled="
                                              $v.workshopForm.timeSchedule
                                                .$invalid
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div
                                        class="time-error"
                                        v-if="timeEndE.length !== 0"
                                      >
                                        {{ timeEndE[0] }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex
                                      xs12
                                      md6
                                      style="padding-right: 15px"
                                    >
                                      <v-autocomplete
                                        v-model="$v.workshopForm.shift.$model"
                                        :items="shifts"
                                        :item-text="shiftText"
                                        :error-messages="shiftErrors"
                                        item-value="id"
                                        label="Turno"
                                        @change="onChanged"
                                        required
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-form>
                              </v-flex>
                            </v-flex>
                            <v-flex xs6 sm6 shrink />
                          </v-layout>
                          <v-layout row class="separatorNotice mt-2">
                            <h2
                              class="font-weight-regular white--text separatorTittle"
                            >
                              Datos de la clase
                            </h2>
                          </v-layout>
                          <v-layout wrap row justify-center>
                            <v-flex x6 sm6>
                              <v-flex xs12>
                                <v-form
                                  lazy-validation
                                  @submit.prevent="submit"
                                >
                                  <v-layout
                                    wrap
                                    justify-space-around
                                    fill-height
                                    align-center
                                  >
                                    <!-- <v-flex
                                      xs12
                                      sm12
                                    >
                                      <v-text-field
                                        label="Salón"
                                        v-model="$v.workshopForm.room.$model"
                                        outline
                                        :error-messages="titleErrors"
                                        style=" margin-top: 25px;"
                                      />
                                    </v-flex> -->
                                    <v-flex xs12 sm12>
                                      <v-autocomplete
                                        v-model="
                                          $v.workshopForm.classroom.$model
                                        "
                                        :items="classRooms"
                                        :item-text="classRoomText"
                                        :no-data-text="'No hay registros'"
                                        item-value="classroomId"
                                        label="Salón"
                                        @change="onChanged"
                                        required
                                        :error-messages="classRoomErrors"
                                      />
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex>
                                      <v-autocomplete
                                        v-model="
                                          $v.workshopForm.employee.$model
                                        "
                                        :items="collaborators"
                                        :item-text="collaboratorText"
                                        item-value="id"
                                        label="Colaborador"
                                        @change="onChanged"
                                        required
                                        :error-messages="collaboratorErrors"
                                      />
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex>
                                      <v-checkbox
                                        color="primary"
                                        v-model="quotaStatus"
                                        @change="quotaStatusChange"
                                        style="
                                          margin-left: 10px;
                                          display: inline-block;
                                        "
                                      >
                                        <template v-slot:label>
                                          Cupo limitado
                                        </template>
                                      </v-checkbox>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout
                                    wrap
                                    justify-space-around
                                    fill-height
                                    align-center
                                    v-if="quotaStatus"
                                  >
                                    <v-flex xs12 sm12>
                                      <v-text-field
                                        label="Cupo"
                                        v-model="
                                          $v.workshopForm.quotaLimit.$model
                                        "
                                        outline
                                        type="number"
                                        min="1"
                                      />
                                    </v-flex>
                                  </v-layout>
                                  <v-layout
                                    wrap
                                    justify-space-around
                                    fill-height
                                    align-center
                                  >
                                    <v-flex xs12 sm12>
                                      <v-text-field
                                        label="Clasificación/TAG"
                                        v-model="$v.workshopForm.tag.$model"
                                        outline
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-form>
                              </v-flex>
                            </v-flex>
                            <v-flex xs6 sm6 shrink />
                          </v-layout>
                        </v-form>
                      </v-flex>
                    </v-layout>
                  </v-stepper-content>

                  <!-- <v-stepper-content :step="2">
                    asdasd
                  </v-stepper-content>

                  <v-stepper-content :step="3">
                    asdasd
                  </v-stepper-content> -->
                </v-stepper-items>
              </v-stepper>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="close" flat> Cancelar </v-btn>
          <v-spacer />
          <v-btn small color="primary" dark @click="save">
            {{
              workshopEdit === null || workshopEdit === undefined
                ? 'Crear'
                : 'Guardar'
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog
      v-model="modals2.confirma"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3 justify-center">
          <span class="white--text">{{ modals2.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="justify-center">
              <h4 class="justify-center">
                {{ modals2.descripcion }}
              </h4>
            </v-layout>
            <br>
            <br>
            <v-layout class="justify-center">
              <h3>{{ modals2.question }} </h3> 
            </v-layout>
            <br>
            <v-layout class="justify-center">
              <v-btn
                class="primary"
                @click="modals2.confirma = false;"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="black"
                dark
                @click="createNotice2(); modals2.confirma = false;"
              >
                {{ this.modals2.btnText }}
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <success v-model="toast.success" text="Operación Exitosa" />
    <error v-model="toast.failed" :text="messageError" />
    <loading text="Trabajando..." v-model="toast.loading" />
  </div>
</template>

<script>
import moment from 'moment'

import { ableDays } from '@/Catalogs/mapSettings'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { getMessageError, isEmptyOrNull } from '../../../plugins/GeneralMethods'
import Error from '../../Dialogs/Error.vue'
import Loading from '../../Dialogs/Loading.vue'
import Success from '../../Dialogs/Success.vue'
import WorkshopImage from '../../Sections/workshop/WorkshopImage.vue'

export default {
  components: {
    WorkshopImage,
    VueTimepicker,
    Success,
    Error,
    Loading,
  },
  validations: {
    workshopForm: {
      id: {},
      name: { required },
      description: { required },
      strStartDate: { required },
      strEndDate: { required },
      imageStorage: {},
      days: { required },
      shift: { required },
      classroom: { required },
      employee: { required },
      quotaLimit: {},
      tag: {},
      timeSchedule: {
        required,
        validateDateStart() {
          if (this.validateTime(this.workshopForm.timeSchedule)) {
            return true
          }
          return false
        },
      },
      timeEndSchedule: {
        required,
        validateDateEnd() {
          if (this.validateTime(this.workshopForm.timeEndSchedule)) {
            let startTime = this.getScheduleTimeToSave(
              this.$v.workshopForm.timeSchedule.$model
            )
            let strStartDate = new Date('1970-01-01T' + startTime + 'Z')
            let endTime = this.getScheduleTimeToSave(
              this.$v.workshopForm.timeEndSchedule.$model
            )
            let strEndDate = new Date('1970-01-01T' + endTime + 'Z')
            this.timeEndE = []
            if (strStartDate >= strEndDate) {
              this.timeEndE.push(
                'La hora de fin debe ser mayor que la de inicio'
              )
              return false
            }
            return true
          }
          return false
        },
      },
    },
  },
  props: ['value', 'workshopEdit'],
  mounted() {
    console.log(this.getBranch)
    if (this.getBranch.id != null) {
      this.getClassRooms()
      this.getCollaborators()
    }
  },
  data: () => ({
    e1: 0,
    disabled: false,
    workshopForm: {
      id: '',
      name: '',
      description: '',
      strStartDate: '',
      strEndDate: '',
      imageStorage: [],
      days: '',
      shift: '',
      classroom: '',
      employee: '',
      quotaLimit: '0',
      tag: '',
      timeSchedule: { hh: '', mm: '', a: '' },
      timeEndSchedule: { hh: '', mm: '', a: '' },
      status: '',
    },
    shifts: [
      {
        id: 'M',
        text: 'Matutino',
      },
      {
        id: 'V',
        text: 'Vespertino',
      },
    ],
    startDateMenu: false,
    endDateMenu: false,
    strStartDate: null,
    strEndDate: null,
    scheduleTime: null,
    collaborators: [],
    quotaStatus: false,
    toast: {
      success: false,
      failed: false,
      loading: false,
    },
    timeStartE: [],
    timeEndE: [],
    classRooms: [],
    messageError: 'Ups, ocurrió un error',
  }),
  watch: {
    workshopEdit() {
      if (this.workshopEdit === null || this.workshopEdit === undefined) {
        this.resetData()
        return
      }
      this.workshop = this.workshopEdit
      this.workshopForm.id = this.workshop.id
      this.workshopForm.name = this.workshop.name
      this.workshopForm.description = this.workshop.description
      this.workshopForm.strStartDate = moment(
        new Date(this.workshop.strStartDate)
      ).format('yyyy-MM-DD')
      this.workshopForm.strEndDate = moment(
        new Date(this.workshop.strEndDate)
      ).format('yyyy-MM-DD')
      this.workshopForm.days = this.getDaysSelected()
      this.workshopForm.shift = this.workshop.shift
      this.workshopForm.classroom = this.workshop.classroom.classroomId
      this.workshopForm.employee = this.workshop.employee.id
      this.workshopForm.quotaLimit = this.workshop.quotaLimit
      this.workshopForm.tag = this.workshop.tag
      this.workshopForm.status = this.workshop.status
      this.workshopForm.timeSchedule = this.getScheduleTime(
        this.workshop.timeSchedule
      )
      this.workshopForm.timeEndSchedule = this.getScheduleTime(
        this.workshop.timeEndSchedule
      )
      this.quotaStatus = this.workshop.quotaLimit === '0' ? true : false
      if (!isEmptyOrNull(this.workshop.imageStorage)) {
        this.workshopForm.imageStorage = this.workshop.imageStorage
      } else {
        this.workshopForm.imageStorage = []
      }
    },
    getBranch() {
      console.log(this.getBranch)
      if (this.getBranch.id != null) {
        this.getClassRooms()
        this.getCollaborators()
      }
    },
  },
  computed: {
    titleErrors() {
      const errors = []
      if (!this.$v.workshopForm.name.$dirty) return errors
      !this.$v.workshopForm.name.required &&
        errors.push('El título es obligatorio')
      return errors
    },
    descriptionErrors() {
      const errors = []
      if (!this.$v.workshopForm.description.$dirty) return errors
      !this.$v.workshopForm.description.required &&
        errors.push('La descripción es obligatoria')
      return errors
    },
    dateStartErrors() {
      const errors = []
      if (!this.$v.workshopForm.strStartDate.$dirty) return errors
      !this.$v.workshopForm.strStartDate.required &&
        errors.push('Fecha de inicio obligatoria')
      return errors
    },
    dateEndErrors() {
      const errors = []
      if (!this.$v.workshopForm.strEndDate.$dirty) return errors
      !this.$v.workshopForm.strEndDate.required &&
        errors.push('Fecha de fin obligatoria')
      return errors
    },
    daysErros() {
      const errors = []
      if (!this.$v.workshopForm.days.$dirty) return errors
      !this.$v.workshopForm.days.required &&
        errors.push('Los días son obligatorios')
      return errors
    },
    shiftErrors() {
      const errors = []
      if (!this.$v.workshopForm.shift.$dirty) return errors
      !this.$v.workshopForm.shift.required &&
        errors.push('El turno es obligatorio')
      return errors
    },
    classRoomErrors() {
      const errors = []
      if (!this.$v.workshopForm.classroom.$dirty) return errors
      !this.$v.workshopForm.classroom.required &&
        errors.push('El salón es obligatorio')
      return errors
    },
    collaboratorErrors() {
      const errors = []
      if (!this.$v.workshopForm.employee.$dirty) return errors
      !this.$v.workshopForm.employee.required &&
        errors.push('El colaborador es obligatorio')
      return errors
    },
    momentFormatStartDate() {
      if (!isEmptyOrNull(this.$v.workshopForm.strStartDate.$model)) {
        return moment(this.$v.workshopForm.strStartDate.$model).format(
          'DD/MM/YYYY'
        )
      }
      return ''
    },
    momentFormatEndDate() {
      if (!isEmptyOrNull(this.$v.workshopForm.strEndDate.$model)) {
        return moment(this.$v.workshopForm.strEndDate.$model).format(
          'DD/MM/YYYY'
        )
      }
      return ''
    },
    momentFormatStartTime() {
      this.timeStartError()
      if (!isEmptyOrNull(this.$v.workshopForm.timeSchedule.$model)) {
        return moment(this.$v.workshopForm.timeSchedule.$model).format(
          'DD/MM/YYYY'
        )
      }
      return null
    },
    momentFormaEndTime() {
      this.timeEndError()
      if (!isEmptyOrNull(this.$v.workshopForm.timeEndSchedule.$model)) {
        return moment(this.$v.workshopForm.timeEndSchedule.$model).format(
          'DD/MM/YYYY'
        )
      }
      return null
    },
    enableDays() {
      return ableDays
    },
    ...mapGetters(['getBranch']),
  },
  methods: {
    validateTime(scheduleTime) {
      return (
        scheduleTime.hh != '' && scheduleTime.mm != '' && scheduleTime.a != ''
      )
    },
    timeStartError() {
      this.timeStartE = []
      if (!this.$v.workshopForm.timeSchedule.$dirty) return this.timeStartE
      if (!this.$v.workshopForm.timeSchedule.$invalid) return this.timeEndE
      this.timeStartE.push('La hora de inicio es obligatoria')
      return this.timeStartE
    },
    timeEndError() {
      this.timeEndE = []
      if (!this.$v.workshopForm.timeEndSchedule.$dirty) return this.timeEndE
      if (!this.$v.workshopForm.timeEndSchedule.$invalid) return this.timeEndE
      this.timeEndE.push('La hora de fin es obligatoria')
      return this.timeEndE
    },
    classRoomText(classRoom) {
      return classRoom.classroomName
    },
    getClassRooms() {
      const body = {
        search: '',
        offset: 0,
        size: 100,
      }
      this.$store
        .dispatch('classRoom/getClassrooms', body)
        .then((response) => {
          this.classRooms = response.data.entity
        })
        .catch((response) => {
          this.messageError = getMessageError(response.data)
          this.toast.failed = true
          this.classRooms = []
        })
    },
    getTitle() {
      return isEmptyOrNull(this.workshopEdit) ? 'Crear taller' : 'Editar taller'
    },
    getCollaborators() {
      const payload = {}
      payload.size = 1000
      payload.offset = 0

      this.$store
        .dispatch('employee/getEmployees', payload)
        .then((response) => {
          this.collaborators = response.data.data
        })
        .catch((error) => {
          this.collaborators = []
        })
    },
    save() {
      this.$v.workshopForm.$touch()
      if (!this.$v.workshopForm.$invalid) {
        var objc = JSON.parse(JSON.stringify(this.workshopForm))
        objc.timeSchedule = this.getScheduleTimeToSave(
          this.$v.workshopForm.timeSchedule.$model
        )
        objc.timeEndSchedule = this.getScheduleTimeToSave(
          this.$v.workshopForm.timeEndSchedule.$model
        )
        objc.employee = { id: objc.employee }
        objc.classroom = { classroomId: objc.classroom }
        objc.days = this.getDaysToSave()
        objc.strStartDate = this.getDateToSave(objc.strStartDate)
        objc.strEndDate = this.getDateToSave(objc.strEndDate)
        this.toast.loading = true
        if (this.workshopEdit === null || this.workshopEdit === undefined) {
          objc.status = undefined
          objc.id = undefined
          this.$store
            .dispatch('workshop/createWorkshop', objc)
            .then(() => {
              this.toast.loading = false
              this.toast.success = true
              this.close()
            })
            .catch((response) => {
              this.messageError = getMessageError(response.data)
              this.toast.loading = false
              this.toast.failed = true
            })
        } else {
          // objc.branch = this.getBranch
          this.$store
            .dispatch('workshop/updateWorkshop', objc)
            .then(() => {
              this.toast.success = true
              this.toast.loading = false
              this.close()
            })
            .catch((response) => {
              this.messageError = getMessageError(response.data)
              this.toast.loading = false
              this.toast.failed = true
            })
        }
        console.log(this.workshopForm)
      }
    },
    close() {
      this.$emit('input', false)
      this.$emit('close')
      this.resetData()
    },
    shiftText(shift) {
      return shift.text
    },
    collaboratorText(collaborator) {
      return collaborator.firstName + ' ' + collaborator.lastName
    },
    onChanged(e) {
      console.log(e)
    },
    quotaStatusChange() {
      this.workshopForm.quotaLimit = 0
    },
    getDateFromString(dateString) {
      return Date(dateString)
    },
    getDaysSelected() {
      const daysSplit = this.workshop.days.split(',')
      const days = []
      ableDays.forEach((it) => {
        daysSplit.forEach((day) => {
          if (it.name === day) {
            days.push(it)
          }
        })
      })
      return days
    },
    getScheduleTime(timeString) {
      const d = moment(new Date()).format('yyyy-MM-DD') // d = "12/12/2017"
      const date = moment(d + 'T' + timeString).format()
      var hora = moment(date).format('HH')
      var type = 'am'
      if (hora == 0) {
        hora = '12'
        type = 'am'
      } else {
        if (hora >= 12) {
          type = 'pm'
        }
      }
      var minutos = moment(date).format('mm')
      var horaFix = '0'
      var dateString = ''
      if (Number(hora) > 12) {
        hora = Number(hora) - 12
        type = 'pm'
        if (Number(hora) < 21) {
          horaFix = horaFix.concat(hora)
        } else {
          horaFix = hora
        }
        dateString = { hh: horaFix, mm: minutos, a: type }
      } else {
        dateString = { hh: hora, mm: minutos, a: type }
      }
      return dateString
    },
    getScheduleTimeToSave(scheduleTime) {
      if (isEmptyOrNull(scheduleTime)) {
        return
      }
      if (
        scheduleTime.hh != '' &&
        scheduleTime.mm != '' &&
        scheduleTime.a != ''
      ) {
        var hora = scheduleTime.hh
        var type = scheduleTime.a
        if (type == 'am') {
          if (hora == 12) hora = '00'
        } else if (type == 'pm') {
          if (hora == 12) hora = '12'
          else hora = Number(hora) + 12
        }
        let time = hora + ':' + scheduleTime.mm + ':00'
        return time
      } else {
        let time = '00:00:00'
        return time
      }
    },
    resetData() {
      this.workshop = undefined
      this.workshopEdit = undefined
      this.workshopForm.id = ''
      this.workshopForm.name = ''
      this.workshopForm.description = ''
      this.workshopForm.strStartDate = ''
      this.workshopForm.strEndDate = ''
      this.workshopForm.image = ''
      this.workshopForm.days = ''
      this.workshopForm.shift = ''
      this.workshopForm.classroom = ''
      this.workshopForm.employee = ''
      this.workshopForm.quotaLimit = '0'
      this.workshopForm.tag = ''
      this.workshopForm.timeSchedule = { hh: '', mm: '', a: '' }
      this.workshopForm.timeEndSchedule = { hh: '', mm: '', a: '' }
      this.strStartDate = undefined
      this.strEndDate = undefined
      this.scheduleTime = null
      this.quotaStatus = false
      this.$v.workshopForm.name.$reset()
      this.$v.workshopForm.description.$reset()
      this.$v.workshopForm.strStartDate.$reset()
      this.$v.workshopForm.strEndDate.$reset()
      this.$v.workshopForm.imageStorage.$reset()
      this.$v.workshopForm.days.$reset()
      this.$v.workshopForm.shift.$reset()
      this.$v.workshopForm.classroom.$reset()
      this.$v.workshopForm.employee.$reset()
      this.$v.workshopForm.quotaLimit.$reset()
      this.$v.workshopForm.tag.$reset()
      this.$v.workshopForm.timeSchedule.$reset()
      this.$v.workshopForm.timeEndSchedule.$reset()
    },
    getDaysToSave() {
      const daysSelected = this.workshopForm.days
      var daysString = ''
      daysSelected.forEach((it) => {
        daysString += it.name + ','
      })
      return daysString
    },
    getDateToSave(date) {
      if (date != null) {
        return moment(date).format('yyyy-MM-DD')
      }
      return ''
    },
  },
}
</script>

<style scoped>
.pickers {
  justify-content: center;
  align-items: center;
  width: 100%;
}

.date-picker-notice {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.border-class-notice {
  border: 2px solid #757575;
  height: 57px;
  display: flex;
}

.border-class-notice-error {
  border: 2px solid red;
  height: 57px;
  display: flex;
}

.text-normal {
  color: black;
}

.text-error {
  color: red;
}

.time-error {
  color: red;
  font-size: small;
}
</style>
